<template>
  <div>
    <appHeader></appHeader>
    <div class="container-fluid admin-batch-user-upload-tool">
      <div class="row">
        <div class="col-md-3 col-sm-12 pr-0 dark-bg">
          <appAdminSidebar></appAdminSidebar>
        </div>
        <transition appear name="fade">
          <div class="col-md-9 p-4">
            <div class="row">
              <div class="col-sm-6 col-md-6">
                <h4>User Data Batch Process Manager</h4>
              </div>
              <div class="col-sm-6 col-md-6 align-right">
                <a href="/admin-points-faq" target="_blank">Frequently Asked Questions</a>
              </div>
            </div>
            <router-view />
          </div>
        </transition>
      </div>
    </div>
    <appModal></appModal>
    <appFooter></appFooter>
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';
import AdminSidebar from '@/views/admin/AdminSidebar.vue';
import { mapState } from 'vuex';
import Modal from '@/components/Modal.vue';

export default {
  name: 'BatchUserUploadToolMain',

  props: {
    activeMenuItem: String,
    activeMenu: String,
  },

  components: {
    appHeader: Header,
    appFooter: Footer,
    appAdminSidebar: AdminSidebar,
    appModal: Modal,
  },

  data() {
    return {};
  },

  methods: {
    setActiveMenuItem: function() {
      this.$store.dispatch('adminSidebar/setActive', {
        activeMenuItem: this.activeMenuItem ? this.activeMenuItem : 'usersBatchUserUploadTool',
        activeMenu: this.activeMenu ? this.activeMenu : 'users',
      });
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
  },

  computed: {},

  watch: {},

  created() {
    this.setActiveMenuItem();
  },
};
</script>

<style lang="scss" scoped>
.admin-batch-user-upload-tool {
  margin: -14px 0 0 0;
  .badge {
    font-size: 0.8rem;
    padding: 6px 0px;
    border-radius: $border-radius-sm;
  }
}
.align-right {
  text-align: right;
}

.bold-text {
  font-weight: bold;
}

.display-flex {
  display: flex;
}

.marginAll {
  margin: 10px;
}
</style>
